// @ts-nocheck
import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";

const emailsUrl = "/api/v1/custom/form/newsletter";

export interface SubmitSubscribeFormApiParameter extends ApiParameter {
    emailadd?: string;
    emailAddress?: string;
}

export function subscribe(parameter: SubmitSubscribeFormApiParameter) {
    const newParameter = {
        emailadd: parameter.emailAddress,
    };
    return post<SubmitSubscribeFormApiParameter, void>(`${emailsUrl}`, newParameter);
}
